function newPosition(lat, long, id, selector) {
    let icon = 'Pin.svg';
    
    if( carte_type == "roadmap"){
      icon = 'Pin-vert.svg';
    }
    let obj = new Object();
    obj.latitude = lat;
    obj.longitude = long;
    obj.id = id;
    obj.icon = {
        url: site_url + '/assets/images/icons/' + icon,
        scaledSize: new google.maps.Size(40, 40), // scaled size
        origin: new google.maps.Point(0, 0), // origin
        anchor: new google.maps.Point(0, 0) // anchor
    };
    obj.visible = true;
    obj.selector = selector;
    obj.html = {
        content: '',
        popup: false
    };

    return obj;
}

if ($('#map-contact').length) {
    let positionChalets = {lat: 46.5067455, lng: -71.0553494};


    let mapContact = new google.maps.Map(document.getElementById('map-contact'), {
        zoom: 9,
        center: positionChalets,
        maptype: 'roadmap',
        styles: [{"featureType": "landscape", "elementType": "geometry.fill", "stylers": [{"color": "#ebf1f4"}]}, {"featureType": "landscape.man_made", "elementType": "geometry", "stylers": [{"visibility": "off"}]}, {"featureType": "poi", "elementType": "all", "stylers": [{"visibility": "off"}]}, {"featureType": "poi.park", "elementType": "geometry.fill", "stylers": [{"visibility": "on"}, {"hue": "#009cff"}]}, {"featureType": "road", "elementType": "geometry", "stylers": [{"lightness": "100"}]}, {"featureType": "transit", "elementType": "all", "stylers": [{"visibility": "simplified"}]}],
        title: 'Au Chalet au Bois Rond'
    });
    let markerChalet = new google.maps.Marker({
        position: {lat: 46.5067455, lng: -71.0553494},
        map: mapContact,

    });
    let contentString = $('.map-chalet').clone().html()
    let infowindow = new google.maps.InfoWindow({
        content: contentString
    });

    markerChalet.addListener('click', function () {
        infowindow.open(map, markerChalet);
    });
}
if ($('#map').length > 0) {

    let markers = [];
    let chalets = [];
    let modalMap = $('.carte .std_card--fullwidth.std_card, .carte .std_card--fullwidth');

    $('.chalet-item').each(function () {
        let long = parseFloat($(this).data('long'));
        let lat = parseFloat($(this).data('lat'));
        let id = $(this).data('id');
        let pos = newPosition(lat, long, 'chalet-' + id, '.chalet-item');
        chalets.push(pos);
    });


    
    let themap = {};
    $(function () {
        let position = {lat: 46.842528, lng: -71.9381946};
        markers = chalets
        themap = $("#map").goMap({
            mapTypeId: google.maps.MapTypeId.SATELLITE,
            zoom: 15,
            maptype: carte_type,
            center: position,
            draggable: true,
            zoomControl: true,
            navigationControl: true,
            scrollwheel: false,
            markers: markers,
            styles: '',
        });

        //on drag map, close modal marker
        map.addListener('center_changed', function () {
            modalMap.hide();
        });
        $.goMap.map.panTo({lat: 46.842528, lng: -71.9381946});
        //hide modal marker
        $(".close-modal").click(function (e) {
            e.preventDefault();
            $(this).parent().hide();
        });

    });

}



$('#map-image .btn-zoom').on('click', function(e){
    e.preventDefault();
    let zoom = $(this).attr('data-zoom');
    let img =  $('#map-image img');
    let he = img.height(); 
    
    if(zoom == 'in'){
      img.height(he + 50);  
    }else {
        if(img.width() > $(this).parent().width() + 50){

            img.height(he - 50);   
        }
    }
    
})